import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceCollaboration, ServiceCollaborationInput} from './service-collaboration.model';

export const loadServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Load ServiceCollaborations',
  props<{ serviceCollaborations: ServiceCollaboration[] }>()
);

export const addServiceCollaboration = createAction(
  '[ServiceCollaboration/API] Add ServiceCollaboration',
  props<{ serviceCollaboration: ServiceCollaboration }>()
);

export const upsertServiceCollaboration = createAction(
  '[ServiceCollaboration/API] Upsert ServiceCollaboration',
  props<{ serviceCollaboration: ServiceCollaboration }>()
);

export const addServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Add ServiceCollaborations',
  props<{ serviceCollaborations: ServiceCollaboration[] }>()
);

export const upsertServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Upsert ServiceCollaborations',
  props<{ serviceCollaborations: ServiceCollaboration[] }>()
);

export const updateServiceCollaboration = createAction(
  '[ServiceCollaboration/API] Update ServiceCollaboration',
  props<{ serviceCollaboration: Update<ServiceCollaboration> }>()
);

export const updateServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Update ServiceCollaborations',
  props<{ serviceCollaborations: Update<ServiceCollaboration>[] }>()
);

export const deleteServiceCollaboration = createAction(
  '[ServiceCollaboration/API] Delete ServiceCollaboration',
  props<{ id: string }>()
);

export const deleteServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Delete ServiceCollaborations',
  props<{ ids: string[] }>()
);

export const clearServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Clear ServiceCollaborations'
);

// CUSTOM ACTIONS
export const createServiceCollaborationMutation = createAction(
  '[ServiceCollaboration/API] Create ServiceCollaboration',
  props<{ input: ServiceCollaborationInput }>()
);

export const updateServiceCollaborationMutation = createAction(
  '[ServiceCollaboration/API] update ServiceCollaboration',
  props<{ input: ServiceCollaborationInput }>()
);

export const getAllServiceCollaborations = createAction(
  '[ServiceCollaboration/API] Get all ServiceCollaborations',
  props<{ serviceUniqueId: string }>()
);

export const removeServiceCollaboration = createAction(
  '[ServiceCollaboration/API] remove ServiceCollaboration',
  props<{ uniqueId?: string; id?: string; }>()
);
